import React from 'react'
import { Paper, Stack } from '@mui/material'
import GuidanceNote from '../GuidanceNote'

export default function MobileDateRangeSearchCard({
  children,
  noteTitle = 'Nota:',
  noteMessage = 'Solo puedes escoger un rango de fechas máximo de 12 meses.'
}) {
  return (
    <Paper elevation={0} variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Stack spacing={2}>
        {children}
        <GuidanceNote
          title={noteTitle}
          message={noteMessage}
          singleLine
          sx={{ width: '100%' }}
        />
      </Stack>
    </Paper>
  )
}
